import { createAction } from "typesafe-actions";
import { SearchActionTypes } from "./search-types";
import { ISearchState, ISearchParams } from "./search-reducer";

export interface ISearchRequest extends ISearchParams {
    apiUrl: string;
}

export interface ISearchResponse
    extends Pick<
            ISearchState,
            "products" | "displayedProductsOutOfTotalLabel" | "productsTotalCount" | "productsTotalCountLabel"
        >,
        Pick<ISearchParams, "page"> {}

export interface IPopulateSearch extends Pick<ISearchState, "products"> {}

export const searchRequest = createAction(
    SearchActionTypes.SEARCH_REQUEST,
    action => (payload: ISearchRequest) => action(payload)
);

export const searchSuccess = createAction(
    SearchActionTypes.SEARCH_SUCCESS,
    action => (payload: ISearchResponse) => action(payload)
);
export const searchError = createAction(SearchActionTypes.SEARCH_ERROR);

export const populateSearch = createAction(
    SearchActionTypes.POPULATE_SEARCH,
    action => (payload: IPopulateSearch) => action(payload)
);

export const updateSearchParams = createAction(
    SearchActionTypes.UPDATE_SEARCH_PARAMS,
    action => (payload: ISearchParams) => action(payload)
);
